<ng-container *transloco="let t">
  <section class="reactivate-payment" [class.error]="error" [class.success]="paymentSuccess">
    @if (!error) {
      @if (!paymentSuccess) {
        <section class="debt">
          <div class="debt__total">
            <div class="debt__title">{{ t('reactivate.totalToPay') }}</div>
            <div class="debt__amount">{{ subscriptionDebt.total | currencyFormat }}</div>
            <div class="debt__aclaration">
              @if (subscriptionDebt.total === 0) {
                {{ t('reactivate.noChargeToday') }}
              }
              {{ t('reactivate.thenAmount', {
                amount: subscriptionDebt.priceCurrentPlan | currencyFormat,
                period: subscriptionDebt.subscription.billingType === 'YEARLY' ? t('reactivate.periodYear') : t('reactivate.periodMonth')
              }) }}
            </div>
          </div>
          <div class="debt__resume">
            @if (subscriptionDebt.debt) {
              <div class="resume">
                <div class="resume__text">
                  <div class="resume__title">{{ t('reactivate.debtTitle') }}</div>
                  <div class="resume__aclaration">{{ t('reactivate.debtOneTime') }}</div>
                </div>
                <div class="resume__amount">{{ subscriptionDebt.debt | currencyFormat }}</div>
              </div>
            }
            <div class="resume">
              <div class="resume__text">
                <div class="resume__title">{{ planName }}</div>
                <div class="resume__aclaration">
                  {{ subscriptionDebt.subscription.billingType === 'YEARLY' ? t('reactivate.billingYearly') : t('reactivate.billingMonthly') }}
                </div>
                @if (subscriptionDebt.daysRemaining > 0) {
                  <div class="resume__aclaration">
                    {{ t('reactivate.billingStartDate', { date: startBillingDate }) }}
                  </div>
                }
              </div>
              <div class="resume__amount">
                {{ subscriptionDebt.priceCurrentPlan | currencyFormat }}
              </div>
            </div>
          </div>
        </section>
        <section class="form__content">
          <div class="form">
            <div class="payment-method-toggle" role="radiogroup" aria-label="Método de pago">
              <button
                type="button"
                role="radio"
                class="toggle-option"
                [class.active]="selectedPaymentMethod === 'card'"
                [attr.aria-checked]="selectedPaymentMethod === 'card'"
                [disabled]="sending"
                (click)="onPaymentMethodChange('card')"
              >
                {{ t('reactivate.paymentMethodCard') }}
              </button>
              <button
                type="button"
                role="radio"
                class="toggle-option"
                [class.active]="selectedPaymentMethod === 'cbu'"
                [attr.aria-checked]="selectedPaymentMethod === 'cbu'"
                [disabled]="sending"
                (click)="onPaymentMethodChange('cbu')"
              >
                {{ t('reactivate.paymentMethodCbu') }}
              </button>
            </div>

            @if (hasMultipleSteps) {
              <div class="reactivate-stepper">
                <div class="stepper-step" [class.active]="currentStep === 'debt'" [class.completed]="currentStep === 'payment'">
                  <div class="stepper-circle">
                    @if (currentStep === 'payment') {
                      <i class="ci-check"></i>
                    } @else {
                      1
                    }
                  </div>
                  <span class="stepper-label">{{ t('reactivate.stepPayDebt') }}</span>
                </div>
                <div class="stepper-line"></div>
                <div class="stepper-step" [class.active]="currentStep === 'payment'">
                  <div class="stepper-circle">2</div>
                  <span class="stepper-label">{{ t('reactivate.stepPaymentData') }}</span>
                </div>
              </div>
            }

            @if (hasDebt && isCbuSelected && currentStep === 'debt') {
              <pxw-alert type="info" size="sm" class="debt-card-description">
                {{ t('reactivate.debtCardDescription') }}
              </pxw-alert>
            }

            <dx-validation-group #validationGroup>
              @if (showCardForm) {
                <pxw-argentine-payment
                  [cardModel]="cardModel"
                  [showCreditCard]="false"
                ></pxw-argentine-payment>
              }

              @if (showCbuForm) {
                <pxw-argentine-cbu-payment
                  [cbuModel]="cbuModel"
                  [banks]="banks()"
                ></pxw-argentine-cbu-payment>
              }
            </dx-validation-group>
          </div>
          <div class="form__actions">
            @if (hasMultipleSteps && currentStep === 'payment') {
              <pxw-button
                mode="button"
                display="block"
                type="warning"
                size="md"
                (click)="goBackToDebtStep()"
              >
                <i class="ci-short_left"></i>
                {{ t('reactivate.backButton') }}
              </pxw-button>
            }
            <pxw-button
              mode="submit"
              display="block"
              type="warning"
              size="md"
              color="yellow"
              [loading]="sending"
              (click)="processPayment()"
            >
              @if (hasMultipleSteps && currentStep === 'debt') {
                {{ t('reactivate.continueButton') }}
              } @else {
                {{ t('reactivate.reactivateButton') }}
              }
            </pxw-button>
          </div>
        </section>
      } @else {
        <section class="success__content">
          <img src="https://cdn.pedix.app/celebrate.png" alt="" />
          <div class="success__text">
            <h3 class="h3">{{ t('reactivate.successTitle') }}</h3>
            <p class="big">
              {{ t('reactivate.successMessage') }}
            </p>
          </div>
          <pxw-button
            class="celebrate-button"
            mode="submit"
            display="block"
            type="warning"
            size="md"
            color="yellow"
            (click)="goToPedix()"
          >
            {{ t('reactivate.goToPedix') }}
          </pxw-button>
        </section>
      }
    } @else {
      <pxw-alert type="danger" size="sm" display="inline">
        {{ error }}
      </pxw-alert>
    }
  </section>
</ng-container>
